import {
  IS_VERIFY_WALL_FETCHING,
  RESET_CHANGE_EMAIL_FETCHING,
  RESET_OTP_STATE,
  RESET_VERIFY_WALL_FETCHING,
  SAVE_CHANGE_EMAIL_VERIFY_DATA,
  SAVE_EMAIL_VERIFY_DATA,
  SET_CHANGE_EMAIL_FETCHING,
  SET_EMAIL_VERIFY_WALL_DATA,
  SET_OTP_STATE,
} from '../../actions/actionType';
import { CLEAR_JOIN_PREDATA_ACTION, STORE_JOIN_PREDATA_ACTION } from './Join';

export const LOGIN_USER = 'LOGIN_USER';
export const REFRESHING_TOKEN = 'REFRESHING_TOKEN';
export const DONE_REFRESHING_TOKEN = 'DONE_REFRESHING_TOKEN';
export const RESET_TOKEN_VALIDITY = 'RESET_TOKEN_VALIDITY';
export const GDPR_ACKNOWLEDGED = 'GDPR_ACKNOWLEDGED';
export const GDPR_OPEN_STEP2 = 'GDPR_OPEN_STEP2';
export const REMOVE_HTTP_REQUEST = 'REMOVE_HTTP_REQUEST';
export const SET_VIRGIL = 'SET_VIRGIL';
export const UNSET_VIRGIL = 'UNSET_VIRGIL';
export const STORE_RELOADED = 'STORE_RELOADED';
export const AUTH_REMOVE_BLOCK_PROPERTIES = 'AUTH_REMOVE_BLOCK_PROPERTIES';
export const IS_FETCHING = 'IS_FETCHING';
export const IS_LOGOUT = 'IS_LOGOUT';
export const RESET_IS_FETCHING = 'RESET_IS_FETCHING';
export const TEMPORARY_LOGIN_USER = 'TEMPORARY_LOGIN_USER';

export interface FreshTokenPromise {
  freshTokenPromise: Record<string, unknown> | null;
}

export interface ResetTokenValidity {
  resetTokenValidity: boolean;
}

export interface WebTimestamp {
  webTimestamp: string;
  bundleUpdate?: boolean;
}

export interface Location {
  loc?: string | null;
}

export interface HttpRequest extends Location {
  time: number;
}

export interface RequestList {
  requestList: HttpRequest[];
}

export interface JWTToken {
  jwToken: string;
}

export interface UserInfo {
  token?: JWTToken;
  gdpr_acknowledged?: boolean | null | undefined;
  password_disabled?: boolean;
}

export interface AuthState
  extends FreshTokenPromise,
    ResetTokenValidity,
    WebTimestamp,
    RequestList,
    UserInfo,
    JWTToken {
  isAuthenticated: boolean;
  gdpr_Step2: boolean;
  jwtUnixExpiration: string;
  virgil: boolean;
  isRecentlyReloaded: boolean;
  tokenRefreshing: boolean;
  isFetching: boolean;
  isLogout: boolean;
  otpTimer: number;
  isOtpSent: boolean;
  isVerifyEmailFetching: boolean;
  isChangeEmailFetching: boolean;
  facelivenessVerifyLoader?: boolean;
  startSelfieVerification?: boolean;
  changeEmailVerifyData: any;
}

interface LOGIN_USER_ACTION {
  type: typeof LOGIN_USER;
  payload: UserInfo;
}
interface TEMPORARY_LOGIN_USER {
  type: typeof TEMPORARY_LOGIN_USER;
  payload: UserInfo;
}

interface REFRESHING_TOKEN_ACTION {
  type: typeof REFRESHING_TOKEN;
  payload: FreshTokenPromise;
}

interface DONE_REFRESHING_TOKEN_ACTION {
  type: typeof DONE_REFRESHING_TOKEN;
}

interface RESET_TOKEN_VALIDITY_ACTION {
  type: typeof RESET_TOKEN_VALIDITY;
  payload: ResetTokenValidity;
}

interface GDPR_ACKNOWLEDGED_ACTION {
  type: typeof GDPR_ACKNOWLEDGED;
}

interface GDPR_OPEN_STEP2 {
  type: typeof GDPR_OPEN_STEP2;
}

interface REMOVE_HTTP_REQUEST_ACTION {
  type: typeof REMOVE_HTTP_REQUEST;
  payload: Location;
}

interface SET_VIRGIL_ACTION {
  type: typeof SET_VIRGIL;
}

interface UNSET_VIRGIL_ACTION {
  type: typeof UNSET_VIRGIL;
}

interface STORE_RELOADED_ACTION {
  type: typeof STORE_RELOADED;
}

interface AUTH_REMOVE_BLOCK_PROPERTIES_ACTION {
  type: typeof AUTH_REMOVE_BLOCK_PROPERTIES;
}

interface IS_FETCHING_ACTION {
  type: typeof IS_FETCHING;
}
interface IS_LOGOUT_ACTION {
  type: typeof IS_LOGOUT;
  payload: boolean;
}
interface SAVE_EMAIL_VERIFY_DATA_ACTION {
  type: typeof SAVE_EMAIL_VERIFY_DATA;
  payload: any;
}
interface SET_OTP_STATE_ACTION {
  type: typeof SET_OTP_STATE;
}
interface RESET_OTP_STATE_ACTION {
  type: typeof RESET_OTP_STATE;
}

interface SET_EMAIL_VERIFY_WALL_DATA_ACTION {
  type: typeof SET_EMAIL_VERIFY_WALL_DATA;
  payload: any;
}
interface SET_CHANGE_EMAIL_VERIFY_DATA_ACTION {
  type: typeof SAVE_CHANGE_EMAIL_VERIFY_DATA;
  payload: any;
}

interface IS_VERIFY_WALL_FETCHING_ACTION {
  type: typeof IS_VERIFY_WALL_FETCHING;
}

interface RESET_VERIFY_WALL_FETCHING_ACTION {
  type: typeof RESET_VERIFY_WALL_FETCHING;
}
interface SET_CHANGE_EMAIL_FETCHING_ACTION {
  type: typeof SET_CHANGE_EMAIL_FETCHING;
}

interface RESET_CHANGE_EMAIL_FETCHING_ACTION {
  type: typeof RESET_CHANGE_EMAIL_FETCHING;
}

export type AuthActionTypes =
  | LOGIN_USER_ACTION
  | REFRESHING_TOKEN_ACTION
  | DONE_REFRESHING_TOKEN_ACTION
  | RESET_TOKEN_VALIDITY_ACTION
  | GDPR_ACKNOWLEDGED_ACTION
  | GDPR_OPEN_STEP2
  | REMOVE_HTTP_REQUEST_ACTION
  | SET_VIRGIL_ACTION
  | UNSET_VIRGIL_ACTION
  | STORE_RELOADED_ACTION
  | AUTH_REMOVE_BLOCK_PROPERTIES_ACTION
  | IS_FETCHING_ACTION
  | IS_LOGOUT_ACTION
  | SAVE_EMAIL_VERIFY_DATA_ACTION
  | SET_OTP_STATE_ACTION
  | RESET_OTP_STATE_ACTION
  | TEMPORARY_LOGIN_USER
  | SET_EMAIL_VERIFY_WALL_DATA_ACTION
  | IS_VERIFY_WALL_FETCHING_ACTION
  | SET_CHANGE_EMAIL_VERIFY_DATA_ACTION
  | RESET_VERIFY_WALL_FETCHING_ACTION
  | SET_CHANGE_EMAIL_FETCHING_ACTION
  | RESET_CHANGE_EMAIL_FETCHING_ACTION
  | STORE_JOIN_PREDATA_ACTION
  | CLEAR_JOIN_PREDATA_ACTION
  | START_SELFIE_VERIFICATION
  | SET_FACELIVENESS_VERIFY_LOADER;
